import { render, staticRenderFns } from "./DialogNotice.vue?vue&type=template&id=1f0354fc&scoped=true"
import script from "./DialogNotice.vue?vue&type=script&lang=js"
export * from "./DialogNotice.vue?vue&type=script&lang=js"
import style0 from "./DialogNotice.vue?vue&type=style&index=0&id=1f0354fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0354fc",
  null
  
)

export default component.exports